import { FC, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { SvgIconProps } from '@mui/material';
import Icon from '@mdi/react';
import { mdiLinkVariantRemove } from '@mdi/js';
import DownloadIcon from '@mui/icons-material/Download';
import { useTranslation } from '../../i18n';
import { ButtonProps } from './types';
import ButtonTemplate from './MUIButtonTemplate';

export const Delete: FC<ButtonProps> = (props) => {
  const { t } = useTranslation();

  return (
    <ButtonTemplate title={t('Remove')} {...props}>
      <DeleteIcon />
    </ButtonTemplate>
  );
};

export const Edit: FC<ButtonProps> = (props) => {
  const { t } = useTranslation();

  return (
    <ButtonTemplate title={t('Edit')} {...props}>
      <EditIcon />
    </ButtonTemplate>
  );
};

export const Unlink: FC<ButtonProps> = (props) => {
  const { t } = useTranslation();

  return (
    <ButtonTemplate title={t('Unlink')} {...props}>
      <Icon path={mdiLinkVariantRemove} size={1} />
    </ButtonTemplate>
  );
};

export const Toggle: FC<
  ButtonProps & { active: boolean; enableTitle?: string; disableTitle?: string }
> = (props) => {
  const { t } = useTranslation();

  const theme = useTheme();
  const [disabled, setDisabled] = useState(false);
  return (
    <ButtonTemplate
      title={props.active ? props.enableTitle || t('Disable') : props.disableTitle || t('Enable')}
      {...props}
      {...(props.onClick && {
        onClick: async (...rest) => {
          try {
            setDisabled(true);
            if (props.onClick) {
              await props.onClick(...rest);
            }
          } finally {
            setDisabled(false);
          }
        },
        disabled,
      })}
    >
      <PowerSettingsNewIcon
        style={{
          color:
            ((props.disabled || disabled) && theme.palette.grey.A400) ||
            (props.active && theme.palette.success.main) ||
            theme.palette.grey.A200,
        }}
      />
    </ButtonTemplate>
  );
};

export const Close: FC<Partial<ButtonProps & { iconProps: SvgIconProps }>> = (props) => {
  const { t } = useTranslation();

  return (
    <ButtonTemplate title={t('Close')} {...props}>
      <CloseIcon {...props.iconProps} />
    </ButtonTemplate>
  );
};

export const Show: FC<ButtonProps> = (props) => {
  const { t } = useTranslation();

  return (
    <ButtonTemplate title={t('View')} {...props}>
      <VisibilityIcon />
    </ButtonTemplate>
  );
};

export const Download: FC<ButtonProps> = (props) => {
  const { t } = useTranslation();

  return (
    <ButtonTemplate title={t('Getting links to download databases and licenses.')} {...props}>
      <DownloadIcon color="secondary" />
    </ButtonTemplate>
  );
};
